'use strict';

var _ = require('lodash');
var ConfigurationFlightAssignmentTransformerFactory = function ConfigurationFlightAssignmentTransformerFactory(DataTransformer) {
  function ConfigurationFlightAssignmentTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-flight-assignment-mode';
  }
  ConfigurationFlightAssignmentTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationFlightAssignmentTransformer.constructor = ConfigurationFlightAssignmentTransformer;
  ConfigurationFlightAssignmentTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationFlightAssignmentTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationFlightAssignmentTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationFlightAssignmentTransformer.prototype.transform = function (data) {
    var result = [];
    result = _.map(data.domain.flattenedFlightEntities, function (flight) {
      flight.number = parseInt(flight.number);
      return flight;
    });
    return result;
  };
  return ConfigurationFlightAssignmentTransformer;
};
ConfigurationFlightAssignmentTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ConfigurationFlightAssignmentTransformerFactory;